<template>
  <div class="Freequote-main">
    <div class="Freequote-title">免费报价</div>
    <!-- <div class="Science-btn">
      <div class="Science-title"></div>
      <ul>
        <el-radio v-model="radio" label="1">新房装修</el-radio>
        <el-radio v-model="radio" label="2">旧房翻新</el-radio>
      </ul>
    </div>-->
    <div class="Science-btn">
      <div class="Science-title">房屋户型</div>
      <ul>
        <li>
          <el-select v-model="value" placeholder="请选择室">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              style="width:100%"
            ></el-option>
          </el-select>
        </li>
        <li>
          <el-select v-model="value2" placeholder="请选择厅">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </li>
        <li>
          <el-select v-model="value4" placeholder="请选择厨">
            <el-option
              v-for="item in options4"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </li>
        <li>
          <el-select v-model="value3" placeholder="请选择卫">
            <el-option
              v-for="item in options3"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </li>
      </ul>
    </div>
    <div class="Science-btn">
      <div class="Science-title">房屋面积</div>
      <ul>
        <li>
          <el-input v-model="measure" placeholder="请输入面积㎡"></el-input>
        </li>
      </ul>
    </div>
    <div class="Science-btn">
      <div class="Science-title">装修城市</div>
      <ul>
        <li style="width:100%">
          <VDistpicker
            :province="ruleForm.clientprovince"
            :city="ruleForm.clientcity"
            :area="ruleForm.county"
            @province="onChangeProvince"
            @city="onChangeCity"
            @area="onChangearea"
          ></VDistpicker>
        </li>
      </ul>
    </div>
    <div class="Science-btn">
      <div class="Science-title">电话号码</div>
      <ul>
        <li style="width:260px">
          <el-input v-model="phone" placeholder="请输入电话号码"></el-input>
        </li>
      </ul>
    </div>
    <transition name="slide-fade">
      <div class="Mask wow bounceInUp" v-if="offershow">
        <div class="mask-main2">
          <i @click="offer" class="iconfont icon-guanbi"></i>
          <QuickQuotation :databiog="datas"></QuickQuotation>
        </div>
      </div>
    </transition>
    <div class="btns">
      <el-button @click="clickshow">立即申请</el-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import selects from "./selects.vue";
import VDistpicker from "v-distpicker";
import QuickQuotation from "../components/QuickQuotation.vue";
export default {
  components: {
    selects,
    VDistpicker,
    QuickQuotation
  },
  data() {
    return {
      ruleForm: {
        clientprovince: "",
        clientcity: "",
        county: ""
      },
      titles: "请选择室",
      titles2: "请选择厅",
      titles3: "请选择卫",
      titles4: "请选择厨",
      citys: "请选择城市",
      Province: "请选择省份",
      phone: "",
      radio: "1",
      measure: "",
      offershow: false,
      options: [
        {
          value: "一室",
          label: "一室"
        },
        {
          value: "二室",
          label: "二室"
        },
        {
          value: "三室",
          label: "三室"
        },
        {
          value: "四室",
          label: "四室"
        },
        {
          value: "五室",
          label: "五室"
        }
      ],
      options2: [
        {
          value: "一厅",
          label: "一厅"
        },
        {
          value: "二厅",
          label: "二厅"
        },
        {
          value: "三厅",
          label: "三厅"
        }
      ],
      options3: [
        {
          value: 1,
          label: "一卫"
        },
        {
          value: 2,
          label: "二卫"
        },
        {
          value: 3,
          label: "三卫"
        }
      ],
      options4: [
        {
          value: 1,
          label: "一厨"
        },
        {
          value: 2,
          label: "二厨"
        },
        {
          value: 3,
          label: "三厨"
        }
      ],
      //室
      value: "",
      //厅
      value2: "",
      //厨
      value4: "",
      //卫
      value3: "",
      datas: ""
    };
  },
  methods: {
    clickshow: async function() {
      if (this.phone == "") {
        this.$message({
          message: "电话号码不能为空",
          type: "warning"
        });
        return false;
      }
      if (/^1[3-9]\d{9}$/.test(this.phone) == false) {
        this.$message({
          message: "电话号码格式不正确",
          type: "warning"
        });
        return false;
      }

      let datas = {
        state: 1,
        room: this.value,
        office: this.value2,
        kitchen: this.value4,
        Wei: this.value3,
        measure: this.measure
      };
      this.datas = datas;
      let ruleForm = this.ruleForm;
      let data = {
        clientcity: ruleForm.clientcity,
        clientname: "admin",
        clientprovince: ruleForm.clientprovince,
        county: ruleForm.county,
        moblephone: this.phone,
        source: "1",
        registertype: "4",
        remark:
          this.value + this.value2 + this.value4 + "厨" + this.value3 + "卫"
      };
      //console.log("555", data);
      let res = await this.exequy.Immediate(data);

      if (res.data.msg == "success") {
        this.offershow = true;
      }
    },
    onChangeProvince(data) {
      this.ruleForm.clientprovince = data.value;
      //console.log("hshshshsh", this.ruleForm.clientprovince);
    },
    onChangeCity(data) {
      this.ruleForm.clientcity = data.value;
    },
    onChangearea(data) {
      this.ruleForm.county = data.value;
    },
    offer() {
      this.offershow = false;
    }
  }
};
</script>
<style scoped>
.Freequote {
  width: 50%;
  overflow: hidden;
  /* margin-top: 50px; */
  float: left;
}
.Freequote-title {
  width: 100%;
  color: #000;
  font-size: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.Science-btn {
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 10px;
  border-left: 1px solid #000;
  padding-left: 55px;
}
.Science-btn ul {
  overflow: hidden;
  padding-inline-start: 0px;
}
.Science-btn ul li {
  list-style: none;
  width: 120px;
  float: left;
  margin-left: 20px;
}
.btns {
  margin-bottom: 20px;
}
.btns >>> .el-button--default {
  width: 131px;
  background: #b31d25;
  color: #fff;
}
.distpicker-address-wrapper >>> select {
  float: left;
  border: 1px solid #dcdfe6;
}
.distpicker-address-wrapper >>> select:nth-child(n + 2) {
  margin-left: 10px;
  width: 87px;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.Science-title {
  font-size: 17px;
  color: #000;
}
.mask-main2 {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
  overflow-y: scroll;
  overflow-x: hidden;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
